/**
 * @usedBy ThfModalPasswordRecoveryComponent
 *
 * @description
 *
 * *Enum* para especificaÃ§Ã£o do tipo de recuperaÃ§Ã£o de senha.
 */
export enum ThfModalPasswordRecoveryType {
  /** Possibilita ao usuÃ¡rio optar por envio via email ou SMS */
  All = 'all',

  /** DefiniÃ§Ã£o para recuperaÃ§Ã£o apenas por email */
  Email = 'email',

  /** DefiniÃ§Ã£o para recuperaÃ§Ã£o apenas por SMS */
  SMS = 'sms'

}
